module.exports = __webpack_public_path__ + "img/facilities.dd84e8fc.svg";